import { useQuery } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { AxiosError } from 'axios'

import { fetchCustomerDetails } from '../functions/fetchCustomerDetails'

function useFetchCustomerDetails(customerId: number) {
  const { replace } = useNavigation()
  const toast = useToast()
  return useQuery(
    ['fetchedCustomerDetails', customerId],
    () => fetchCustomerDetails(customerId),
    {
      onError: (error: AxiosError) => {
        if (error?.response?.data?.error?.code === 4004) {
          replace('HomeView')
          toast?.show({
            intent: 'error',
            heading: error?.response?.data?.error?.message,
            hideAfter: 2000,
          })
        }
      },
      enabled: !!customerId,
    }
  )
}
export { useFetchCustomerDetails }
